import { render, staticRenderFns } from "./kyc-video.vue?vue&type=template&id=f0bea1c8&scoped=true"
import script from "./kyc-video.vue?vue&type=script&lang=js"
export * from "./kyc-video.vue?vue&type=script&lang=js"
import style0 from "./kyc-video.vue?vue&type=style&index=0&id=f0bea1c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bea1c8",
  null
  
)

export default component.exports